// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3M9zd","header":"PatientQuestionnaire_header__3zPNC","info":"PatientQuestionnaire_info__2eUfd"};